import axios from "axios";
import { getKeycloackToken } from "./auth";
import * as types from "../constants/approvalConstant";
import qs from "qs";
import { async } from "rxjs";
import { dispatch } from "rxjs/internal/observable/pairs";
import { notify } from "./snack";

export const getApprovals =
  (skillId, options, approval_id) => async (dispatch) => {
    try {
      var token = await getKeycloackToken();
      let filters = qs.stringify(options?.filters || {});
      const config = {
        method: "get",
        url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/approvals?skillId=${skillId}&${filters}&approval_id=${approval_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios(config);
      dispatch({
        type: types.GET_APPROVALS,
        approvals: data.approvals,
      });
    } catch (e) {
      console.log(e.toString());
    }
  };

export const getAllApprovals = (options, deepSearch) => async (dispatch) => {
  try {
    var token = await getKeycloackToken();
    let deepFilters = null;
    if (deepSearch) {
      deepFilters = qs.stringify(deepSearch.search || {});
    }
    let filters = qs.stringify(options?.filters || {});
    const config = {
      method: "get",
      url: `${
        process.env.REACT_APP_BOT_SERVICE_URL
      }/draftSkills/user/approvals?page=${options?.page || 1}&pageSize=${
        options?.pageSize || 100
      }&${filters}&${deepFilters}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios(config);
    dispatch({
      type: types.GET_ALL_APPROVALS,
      approvals: data.approvals,
      isLoadingApproval: false,
      approvalDropdown: data.approvalDropdownList,
      glDropdown: data.glDropdownList
    });
  } catch (e) {
    console.log(e.toString());
  }
};

export const updateApproval =
  (
    id,
    status,
    remarks,
    variables,
    overRideUser,
    dynamicApprovalOptions = null
  ) =>
  async (dispatch) => {
    try {
      var token = await getKeycloackToken();
      const config = {
        method: "put",
        url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/approval/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          status,
          remarks,
          variables,
          overRideUser,
          dynamicApprovalOptions,
        },
      };

      const { data } = await axios(config);
      dispatch({
        type: types.UPDATE_APPROVALS,
        approvals: data.approval,
      });
      if (!data.status) {
        dispatch(notify("error", `${data.error}`));
      }
    } catch (e) {
      dispatch(notify("error", `Failed ${e.toString()}`));
      console.log(e.toString());
    }
  };

export const updateVars = (buildId, variables) => async (dispatch) => {
  try {
    var token = await getKeycloackToken();
    const config = {
      method: "put",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/automationBuildLogs/${buildId}/log-variables`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        variables,
      },
    };

    const { data } = await axios(config);
    // dispatch({
    //   type: types.UPDATE_APPROVALS,
    //   approvals: data.approval,
    // });
  } catch (e) {
    console.log(e.toString());
  }
};

export const getApprovalStats = (start, end, isAdmin) => async (dispatch) => {
  try {
    var token = await getKeycloackToken();
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/approvalStatus?start=${start}&end=${end}&isAdmin=${isAdmin}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios(config);
    return data;
  } catch (e) {
    console.log(e.toString());
  }
};

export const removeApprovalTask = (id) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/approval?id=${id}`,
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios(config);
    return res.data;
  } catch (err) {
    console.log(err.toString());
    dispatch(notify("error", "Task removal failed"));
  }
};
export const setOnHold = (id, holdStatus) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/approvals/onhold`,
      method: "put",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        id: id,
        status: holdStatus ? "incomplete" : "hold",
      },
    };

    const res = await axios(config);
    return res.data;
  } catch (err) {
    console.log(err.toString());
    dispatch(notify("error", "Task removal failed"));
  }
};

export const resetApproval = (id, remarks, variables) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/approvals/reset/${id}`,
      method: "put",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        remarks,
      },
    };

    const res = await axios(config);
    console.log(res, "res");
    return res;
  } catch (err) {
    console.log(err.toString());
    dispatch(notify("error", "Task reset failed"));
  }
};

export const saveApproval = (id, variables) => async (dispatch) => {
  try {
    var token = await getKeycloackToken();
    const config = {
      method: "put",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/saveApproval/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        variables,
      },
    };
    const { data } = await axios(config);

    if (!data.status) {
      dispatch(notify("error", `${data.error}`));
    } else {
      dispatch(notify("success", "Saved Successfully"));
    }
  } catch (e) {
    dispatch(notify("error", `Failed ${e.toString()}`));
    console.log(e.toString());
  }
};

export const saveDropdownList = (dropdownObject) => async (dispatch) => {
  try {
    var token = await getKeycloackToken();
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/approvalDropdownList`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        dropdownObject
      },
    };
    const { data } = await axios(config);

    if (!data.status) {
      dispatch(notify("error", `${data.error}`));
    } else {
      dispatch(notify("success", "Saved Successfully"));
    }
  } catch (e) {
    dispatch(notify("error", `Failed ${e.toString()}`));
    console.log(e.toString());
  }
};
